"use client";

import BannerPage from "@/components/banners/BannerTitle";
import { useLanguage } from "@/contexts/LanguageContext";
import type { HolidayApartment } from "@/payload-types";
import getImageUrl from "@/utils/getImageUrl";
import type { PayLoadData } from "@/utils/payloadUtil";

export function ApartmentPageClient({
  pageData,
}: {
  pageData: PayLoadData<HolidayApartment | undefined> | undefined;
}) {
  const { language } = useLanguage();

  return (
    <BannerPage
      bannerUrl={getImageUrl(pageData?.[language]?.heroBanner.image)}
      title={pageData?.[language]?.heroBanner.title || ""}
      desc={pageData?.[language]?.heroBanner.subtitle || ""}
    />
  );
}
